import T6 from "../../components/ExcerciseTypes/TypeIn/T6";
import Circle_Write from "../../components/ExcerciseTypes/Circle_Write";
import T6v2 from "../../components/ExcerciseTypes/TypeIn/T6v2";

const json = {
  1: {
    unit: "Unit 2",
    id: "FP8-WB-demo-2023-U1-P16-E1",
    audio: "",
    video: "",
    // recorder: true,
    exerciseKey: "/img/FriendsPlus/Page16/Key/E1answerKey.jpg",
    component: Circle_Write,
    inputSize: 200,
    textAlign: "center",
    titleQuestion: [
      {
        num: "1",
        title: `Which word is the odd one out?`,
        color: "rgb(245,128,36)",
        // prefix: { icons: ['far fa-comment'], text: '' },
        star:1
      },
    ],
    question: {
			Write: {
				inputStyle: {
					width: 120,
					textAlign: 'center',
				},
				answers: [``],
				initialValue: [],
			},
			Circle: {
				initialWordStyle: {
					padding: '-40px',
					// fontWeight: 600,
					color: '',
					// fontSize: 27,
					borderRadius: '50%',
          padding:'5px'
					// marginInline: '-1px',
				},
				selectWordStyle: { border: '3px solid rgb(0, 173, 238)' },
				limitSelect: 1,
				listWordsStyle: {},
				listWords: [
					'tasty | delicious | angry',
					'fantastic | scary | wonderful',
					'horrible | disgusting | sad',
					'tired | terrifying | exhausted',
					'interesting | fascinating | disgusting',
				],
				answers: ['0-12', '1-6', '2-12', '3-6', '4-12'],
				initialValue: [],
			},
			Layout: `
      <div>scary&emsp; terrifying&emsp;<span style="border: 3px solid black;border-radius:50%;padding:5px"> delicious</span><div>
			<div><strong style="margin-right:15px">1</strong><input id="0" type="Circle"></div>
			<div><strong style="margin-right:15px">2</strong><input id="1" type="Circle"></div>
			<div><strong style="margin-right:15px">3</strong><input id="2" type="Circle"></div>
			<div><strong style="margin-right:15px">4</strong><input id="3" type="Circle"></div>
			<div><strong style="margin-right:15px">5</strong><input id="4" type="Circle"></div>
					
        `,
		},
  },
  2: {
    unit: "Unit 2",
    id: "FP8-WB-demo-2023-U2-P16-E2",
    audio: "",
    video: "",
    // recorder: true,
    exerciseKey: "/img/FriendsPlus/Page16/Key/E2answerKey.jpg",
    component: T6v2,
    // maxLength: 6,
    inputSize: 180,
    stylesTextInput: {
      background: "transparent",
      border: "none",
      borderBottom: "1px solid gray",
      fontSize: "24px",
      textAlign: "center",
    },
    titleQuestion: [
      {
        num: "2",
        title: `
        Complete the blog post with the words.`,
        color: "rgb(245,128,36)",
        star:2
      },
    ],
    questionImage: [],
    // hideBtnFooter: true,
    isHiddenCheck: true,
    questions: [
      {
        title: `
        <div style='margin-top: 20px; display: flex; gap: 30px;max-width:490px;margin-left:100px;margin-bottom:20px'>
        <div style='flex: 1; border-radius: 20px; padding: 20px 30px; border: 3px solid rgb(245,128,36);'>
          <div><span style="margin-right:20px;text-decoration:line-through">amazing</span><span style="margin-right:20px;">delicious</span><span style="margin-right:20px">disgusting</span><span>exhausted</span></div>
          <div><span style="margin-right:20px;margin-left:120px">fascinating</span><span style="">wonderful</span></div>
          
        </div>
        
      </div>

        <div style='position: relative;'>
          <div><img src='img/FriendsPlus/Page16/E2/1.jpg' width='100%' /></div>
          <div style='position: absolute; top: 110px; left: 60px;'>#</div>
          <div style='position: absolute; top: 239px; left: 60px;'>#</div>
          <div style='position: absolute; top: 281px; left: 409px;'>#</div>
          <div style='position: absolute; top: 368px; left: 132px;'>#</div>
          <div style='position: absolute; top: 414px; left: 282px;'>#</div>

          

          
          
        </div>
      </div>
        `,
        answer: ["fascinating", "delicious", "disgusting", 
          "wonderful", "exhausted"],
      },
    ],
  },
  3: {
    unit: "Unit 2",
    id: "FP8-WB-demo-2023-U1-P16-E3",
    audio: "",
    video: "",
    // recorder: true,
    exerciseKey: "/img/FriendsPlus/Page16/Key/E3answerKey.jpg",
    component: Circle_Write,
    inputSize: 200,
    textAlign: "center",
    titleQuestion: [
      {
        num: "3",
        title: `You are going to listen to an interview. 
        Read the sentences and choose the correct type 
        of answer you should be listening for.`,
        color: "rgb(245,128,36)",
        // prefix: { icons: ['far fa-comment'], text: '' },
        star:2
      },
    ],
    question: {
			Write: {
				inputStyle: {
					width: 120,
					textAlign: 'center',
				},
				answers: [``],
				initialValue: [],
			},
			Circle: {
				initialWordStyle: {
					padding: '-40px',
					// fontWeight: 600,
					color: '',
					// fontSize: 27,
					borderRadius: '50%',
          padding:'5px'
					// marginInline: '-1px',
				},
				selectWordStyle: { border: '3px solid rgb(0, 173, 238)',padding:'5px' },
				limitSelect: 1,
				listWordsStyle: {},
				listWords: [
					'adjective / place',
					'number / name',
					'number / place',
          'adjective / verb',
					' place / time period',
					'adjective / name',
				],
				answers: ['0-4', '1-0', '2-0', '3-4', '4-6', '5-0'],
				initialValue: [],
			},
			Layout: `
      <div>Anna is ........ a who writes about places.<strong><span style="border: 3px solid black;border-radius:50%;padding:5px">job</span>/ verb</strong><div>
			<div><strong style="margin-right:15px">1</strong>Anna saw grey whales in ............... in California.<strong><input id="0" type="Circle"></strong></div>
			<div><strong style="margin-right:15px">2</strong>Around ................ grey whales make the journey every year.<strong><input id="1" type="Circle"></strong></div>
			<div><strong style="margin-right:15px">3</strong>The grey whales travel ............... kilometres, from Alaska to Mexico.<strong><input id="2" type="Circle"></strong></div>
			<div><strong style="margin-right:15px">4</strong>Anna ............. a whale-watching cruise.<strong><input id="3" type="Circle"></strong></div>
			<div><strong style="margin-right:15px">5</strong>You can see the grey whales for ............ every year.<strong><input id="4" type="Circle"></strong></div>
			<div><strong style="margin-right:15px">6</strong>Anna was ........... with herself that she didn’t take any photos.<strong><input id="5" type="Circle"></strong></div>
					
        `,
		},
  },
  4: {
    unit: "Unit 2",
    id: "FP8-WB-demo-2023-U1-P16-E4",
    audio: "/Audios/1-05 Friends Plus 8_WB.mp3",
    video: "",
    component: T6,
    exerciseKey: "/img/FriendsPlus/Page16/Key/E4answerKey.jpg",
    inputSize: 505,
    // recorder: true,
    titleQuestion: [
      {
        num: "4",
        title: `<headphone src="/Audios/1-05 Friends Plus 8_WB.mp3" name="05"></headphone> Listen to the interview and write 
        the answers to the questions in exercise 3.`,
        color: "rgb(245,128,36)",
        star:2
      },
    ],
    // hideBtnFooter: true,
    questions: [
      {
        title: `
          <div>
            <div>Job: <b>travel blogger<b></div>
            <div><strong style="margin-right:15px">1</strong>#</div>
            <div><strong style="margin-right:15px">2</strong>#</div>
            <div><strong style="margin-right:15px">3</strong>#</div>
            <div><strong style="margin-right:15px">4</strong>#</div>
            <div><strong style="margin-right:15px">5</strong>#</div>
            <div><strong style="margin-right:15px">6</strong>#</div>
          </div>

        `,
        answer: ["Dana Point / California","20,000", 
      "almost 10,000 kilometres / 10,000 kilometres","joined", 
      "a few months", "furious"],
      },
    ],
  },
  5: {
    unit: "Unit 2",
    id: "FP8-WB-demo-2023-U1-P16-E5",
    audio: "",
    video: "",
    component: T6,
    exerciseKey: "",
    textareaStyle: { width: 900 },
    hideBtnFooter:true,
    // recorder: true,
    titleQuestion: [
      {
        num: "5",
        title: `
        Write about an interesting place you 
        have visited. Use extreme adjectives.`,
        color: "rgb(245,128,36)",
        star:3
      },
    ],
    // hideBtnFooter: true,
    questions: [
      {
        title: `
              <div>
              <div><b>I’ve visited the Cave of El Castillo in Spain. It has amazing
              cave paintings that are over 40,000 years old. It’s dark
              inside the cave and my younger brother thought it
              was terrifying.</b></div>
              <textarea id="0" rows="8"></textarea>
              </div>

        `,
        answer: [],
      },
    ],
  },
  
};

export default json;
